import carbuyservice from './clients/carBuyService';
import mitelservice from './clients/mitelService';
import myAPI from './resources'

export default {
  authLogin: function (data) {
      return carbuyservice.post('/auth/login', data).then(function (response) {
        return response;
      });
  },
  tokenRenew: function () {
    return carbuyservice.get('/auth/renew', {}, true).then(function (response) {
      return response;
    });
  },
  mitelLogin: function(data) {
    return mitelservice.login(data).then(function(response) {
      return response;
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js